/**
 * @author mll
 * @description pdf导出
 * @Date 2021/05/27
 */

import JsPDF from 'jspdf';
import html2Canvas from 'html2canvas';

/**
 * 单页pdf导出
 * @param {*} fileName 导出的文件名
 * @param {*} pdfDomName dom节点id
 */
const exportPdf = (fileName, shareContent) => {
  var width = shareContent.offsetWidth;
  var height = shareContent.offsetHeight;
  html2Canvas(shareContent, {
    allowTaint: true,
    useCORS: true,// 开启跨域配置
    height,//canvas高
    width, //canvas宽
    scale: 4, //按比例增加分辨率 (2=双倍).
    dpi: window.devicePixelRatio * 4,//设备像素比
  }).then(canvas => {
    var context = canvas.getContext('2d');
    context.mozImageSmoothingEnabled = false;
    context.webkitImageSmoothingEnabled = false;
    context.msImageSmoothingEnabled = false;
    context.imageSmoothingEnabled = false;
    var pageData = canvas.toDataURL('image/jpeg', 1.0);
    var img = new Image();
    img.src = pageData;
    img.onload = function() {
      // 获取dom高度、宽度
      img.width = img.width / 2;
      img.height = img.height / 2;
      img.style.transform = 'scale(0.5)';
      if (width > height) {
        var pdf = new JsPDF('l', 'mm', [width * 0.505, height * 0.545]);
      } else {
        var pdf = new JsPDF('p', 'mm', [width * 0.505, height * 0.545]);
      }
      pdf.addImage(pageData, 'jpeg', 0, 0, width * 0.505, height * 0.545);
      pdf.save(fileName + '.pdf');
    };
  });
};

export { exportPdf };